import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  subOpenOrders: [],
  subOrdersHistory: {},
  subTradesHistory: {},
  subTradesHistoryDetail: {},
};

const handleDeleteOpenOrder = (state, { orderIds }) => {
  const newSubOpenOrders = state.subOpenOrders.filter(item => item.orderId !== Number(orderIds[0]));
  return { ...state, subOpenOrders: [...newSubOpenOrders] };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_SUB_OPEN_ORDERS_SUCCESS:
      return { ...state, subOpenOrders: action.data };
    case actionTypes.DELETE_SUB_OPEN_ORDER_SUCCESS:
      return handleDeleteOpenOrder(state, action.data);
    case actionTypes.FETCH_USER_SUB_ORDERS_HISTORY_SUCCESS:
      return { ...state, subOrdersHistory: action.data };
    case actionTypes.FETCH_USER_SUB_ORDERS_HISTORY_DETAIL_SUCCESS:
      return {
        ...state,
        subTradesHistoryDetail: { ...state.subTradesHistoryDetail, ...action.data },
      };
    case actionTypes.FETCH_USER_SUB_TRADES_HISTORY_SUCCESS:
      return { ...state, subTradesHistory: action.data };
    default:
      return state;
  }
};
